<ul class="menu-items-list">
    @for (item of navigationItems; track item.title) {
        <website-menu-item [item]="item" [level]="1"></website-menu-item>
    }
</ul>
